<template>
  <div class="item-wrap">
    <div
      :class="['item not-selected', {hovering:hovering},{'ui-hidden':hideGlobalUI}]"
      v-toggle-select
      v-toggle-hover
      v-on-clickaway="deselect"
    >
      <transition name="fade">
        <drag-handle v-if="hovering || selected"/>
      </transition>
      <div
        v-if="hovering || item.item_isSpecial"
        :class="['special-icon', {'item-is-special':item.item_isSpecial}]"
        @click.stop="toggleSpecialItem"      
      ></div>

      <div class="item-content">
        <div class="title-and-price">
          <editable-text
            tag="span"
            class="item-title"
            :content="item.item_title"
            :editable="isEditable"
            @update="item.item_title = $event"
            @keydown.enter.native="itemTitleOnKeyupEnter"
            @keydown.tab.native="itemTitleOnKeyupTab"
            ref="itemTitle"
          />
          <price-columns
            v-if="item.item_prices.length || hovering || showUI"
            class="item-prices"
            :prices="item.item_prices"
            :isEditable="isEditable"          
            ref="item-prices"
          />
        </div>
        <editable-text
          v-if="item.item_description.length > 0 || showDescription"
          ref="item-description"
          :class="['item-description']"
          :content="item.item_description"
          :editable="isEditable"
          @update="item.item_description = $event"
        />


      </div> <!-- item-content -->

      <draggable
        class="addons"
        v-model="item.item_addons"
        v-if="item.item_addons.length"
        :options="{draggable:'.addon', group:{pull : 'clone'}, disabled:!this.isAuthenticated }"
        @start="drag=true;addonDragging = true;"
        @end="drag=false;addonDragging = false;"
        @unchoose="addonDragging = false"
        @update="addonDragging = false"
      >
          <menu-item-addon
            :key="addon.addon_uuid"
            v-for="(addon, addon_index) in item.item_addons"
            :addon="addon"
            @removeAddon="removeAddon"
          />
      </draggable>

      <button-cluster
        v-if="!hideGlobalUI"
        :buttons="buttons"
        :item="item"
        :class="[{'addon-dragging':addonDragging && item.item_addons.length}]"
        belowItem
        btnSize="md-16"
      />

    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'
import MenuItemAddon from './MenuItemAddon'
import ButtonCluster from '../UI/ButtonCluster'
import DividedPriceColumns from '../UI/DividedPriceColumns'
import DragHandle from '../UI/DragHandle'

import _random from 'lodash/random'
import _fill from 'lodash/fill'
import _reduce from 'lodash/reduce'
import _each from 'lodash/each'

import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../../toggle-select'
import ToggleHover from '../../toggle-hover'

import { mapGetters } from 'vuex'


export default {

  name: 'MenuItem',
  props : [
    'item',
    'dragging',
    'sectionColumns'
  ],
  data() {
    return {
      images : [
        require('../../../static/citrus-segment-sideways.png'),
      ],
      showDescription : false,
      addonDragging : false,
      buttons : [
        {
          title : 'Option',
          icon : 'add_circle',
          // iconOnly : true,
          // clickHandler : (item) => {
          //   this.addAddon();
          //   // this.$emit('addItem',item.item_uuid);
          // },
          clickHandler : this.addAddon,
          // dragStartAction : this.addButtonDragStart,
          // dragEndAction : this.addButtonDragEnd,
          // dragChangeAction : this.addButtonDragChange,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},

        },
        {
          title : 'Item',
          icon : 'delete',
          // iconOnly : true,
          class: 'delete-item-btn btn-delete-gray',
          dragOptions : {
            group : {
              name : 'trash',
              draggable : '.addon',
              put: () => true,       
              pull : 'false'
            }
          },
          dragModel : [],
          clickHandler : (item) => {this.$emit('removeItem', item.item_uuid); },
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
          dragStartAction : (e)=>{console.log('drag started', e)},
          dragEndAction : (e)=>{console.log('drag Ended', e)},
          dragChangeAction : (e)=>{ this.removeAddon(e.added.element.addon_uuid) },

        },

      ]
    }
  },
  mixins : [ VueClickaway.mixin, ToggleSelect, ToggleHover ],  
  components : {
    draggable,
    'editable-text' : EditableTextField,
    'menu-item-addon' : MenuItemAddon,
    'button-cluster' : ButtonCluster,
    'price-columns' : DividedPriceColumns,
    'drag-handle' : DragHandle,

  },
  computed : {
    showExtras() {
      return this.hovering && !this.disabled && !this.dragging;
    },
    ...mapGetters(['isAuthenticated'])
  },
  created() {
    if( this.item.new ) {
      this.selectDefaultText()
    }
  }, // created

  watch: {
    sectionColumns() {

      // disable for now
      return false;

      if( this.sectionColumns ) {
        let numPrices = this.item.item_prices.length;

        // If there are more section columns than prices
        if( numPrices < this.sectionColumns.length ) {
          // Add some placeholder prices to the items
          let totalFills = this.sectionColumns.length - numPrices;
          for(var i=0; i<totalFills;i++) {
            let currIndex = numPrices + i;
            this.item.item_prices.splice(currIndex,0, {price:'-'})
          }
        }
        // More prices than columns
        else if ( this.item.item_prices && this.sectionColumns ) {
          return false;

          // TODO : Figure out how to force an update on the 
          // editableText field. The 'content' property is updated
          // but the UI is showing the $el.innerText, which hasn't
          // updated yet. Can force it with a watched property, but that
          // causes other problems.
          // 
          // update: apprently contenteditable will move the cursor
          // to the beginning of the element if the innerText is updated
          // programmatically (e.g. a prop is passed, parent updates child, etc)
          // this is a MAJOR dealbreaker. don't know how to proceed.
          // 
          let numCols = this.sectionColumns.length
          let diff = Math.abs(numPrices - numCols)
          let placeholderIndexes = _reduce(this.item.item_prices, (result, priceObj, k) => {
            if( priceObj.price == '-' ) {
              result.push(k)
            }
            return result;
          },[])
          placeholderIndexes = placeholderIndexes.slice(0, diff).reverse();
          this.item.item_prices = this.item.item_prices.filter( (priceObj,i) =>{
            return !placeholderIndexes.includes(i)
          })

        }
      }
      
    }    
  },

  methods: {
    addAddon() {
      if( !this.item.item_addons ) {
        this.item.item_addons = [];
      }
      let newAddonNum = this.item.item_addons.length + 1
      let newAddon = {
        // addon_title : `Addon ${newAddonNum++}`,
        addon_title : 'New Option',
        addon_uuid : Date.now() + newAddonNum + Math.ceil(Math.random(0, 1) * 100),
        // addon_price : _random(1,5),
        addon_price : 0,
        new : true
      };
      this.item.item_addons.push( newAddon )      
    },

    removeAddon(addon_id) {
      this.item.item_addons = this.item.item_addons.filter(addon=> addon.addon_uuid !== addon_id )      
    }, // removeAddon

    itemTitleOnKeyupEnter(e) {
      if( e.shiftKey ) {
        return true;
      }
      e.preventDefault();
      this.showDescription = true
      this.$nextTick().then(this.focusDescription)
    }, // itemTitleOnKeyupEnter    
    
    itemTitleOnKeyupTab(e) {
      if( e.shiftKey ) {
        return true;
      }
      e.preventDefault();
      this.$nextTick().then(this.focusPrice)
    }, // itemTitleOnKeyupTab    

    focusDescription() {
      this.$refs['item-description'].$el.focus();      
    }, // focusDescription

    focusPrice() {
      if( !this.$refs['item-prices'].prices.length ) {
        this.$refs['item-prices'].addFirstPrice();
      }
      this.$refs['item-prices'].$el.focus();      
    }, // focusPrice

    addButtonDragStart() {
      this.addDragging = true;
      this.selected = true
    }, // addButtonDragStart

    addButtonDragEnd() {
      this.addDragging = false;
    }, // addButtonDragEnd

    addButtonDragChange(event) {
      this.dragging = false;
      // if( event.removed ) {
      //   let section = event.removed.element;
      //   section.section_isRecurring = false;
      //   this.menu.acf.sections.push( section )
      // }
      console.log('change')
      if( event.added ) {
        console.log('added')
        // let section = event.added.element;
        // section.section_isRecurring = true;
        // this.menu.acf.sections.push( section )
      }

      // this.el.removeChild(evt.item);
    }, // addButtonDragChange

    selectDefaultText() {
      let self = this;
      this.$nextTick()
        .then( () => {
          var p = this.$refs.itemTitle.$el;
          var s = window.getSelection();
          // start at the beginning of the text
          this.$refs.itemTitle.$el.focus()
          // expand to include the whole text
          s.extend(p.firstChild, p.innerText.length);
        })
    }, // selectDefaultText   

    toggleSpecialItem() {
      if( !this.isAuthenticated ) { return false; }
      this.item.item_isSpecial = !this.item.item_isSpecial      

    }, // toggleSpecialItem
  }, // methods

}
</script>

<style lang="scss" scoped>

$borderWidth : 2px;  
@mixin bgPseudoElem {
  &:before {
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% - #{$borderWidth*2});
    width:calc(100% + 20px);
    right:-20px;
    top:1px;
    bottom:1px;
  }
}

@mixin hoverElem {
  @include bgPseudoElem;
  cursor:pointer;
  &:before {
    border-top:$borderWidth solid darken(white, 7%);
    border-bottom:$borderWidth solid darken(white, 7%);    
  }
  &:not(.selected):before{ 
    background-color:darken(white, 4%);
  }
}

@mixin selectedElem {
  @include hoverElem;
  z-index:1100;
  // background:rgba(138, 251, 109, 0.2);  
  &:before {
    // $border:rgba(138, 251, 109, 0.6);
    $border:#40C2FF;
    $border:#37c120;
    border-top-color:$border;
    border-bottom-color:$border;
  }
}

.item-wrap {
  &.sortable-ghost {
    background:rgba(138, 251, 109, 0.3);
  }  
}

.item {
  position:relative;
  padding-left:20px;
  margin-left:-20px;
  font-size:1.1rem;
  line-height:1.1;
  cursor:pointer;

  &:hover .button-cluster {
    display:flex;
  }

  @include bgPseudoElem;
  &.hovering {
    z-index:1300;    
    @include hoverElem;
  }
  &.selected {
    @include selectedElem;
  }

  [contenteditable] {
    transition:border-color .3s ease, background-color .3s ease;
    border-bottom:2px solid transparent;
  }

  .empty-text {
    // background-color:darken(white, 8%);
    // margin-bottom:2px;
    &:focus, &:active {
      border-bottom:2px solid #40C2FF;
    }
    &:not(.selected):hover {
      background-color:rgba(#40C2FF, .3);
    }
  }

  &.ui-hidden {
    cursor:default;
    &:before {
      display:none !important;
    }
    .special-icon {
      cursor:default;
    }
  }

}

.special-icon {
  transition:opacity .2s ease;
  cursor:pointer;
  opacity:.2;
  position:absolute;
  $scale : 6.7;  
  $width : 100px / $scale;
  $height : 160px / $scale;
  line-height:$height;
  background:url('../../../dist/citrus-segment-sideways.png') no-repeat center center;
  background-size:100%;
  width:$width; 
  height:$height;
  top:5px; // .item padding-top
  left:-$width + 20px - 6px;
  &:hover {
    opacity:.5;
  }
  &.item-is-special {
    opacity:1;
  }
  #menu-manager-app.logged-in & {
    cursor:pointer;
  }
}

.item-content {
  display:flex;
  flex-wrap:wrap;
}

.title-and-price {
  display:flex;
  flex:0 0 100%;
}

.item-title {
  // flex:0 1 85%;
  font-weight:bold;
  // flex: 1 1 50%;
  flex:auto;
}

.item-prices {
  // flex:0 1 15%;
  // flex: 1 1 50%;
  flex:auto;
}
.item-description {
  font-size:.95rem;
  font-style:italic;
  flex: 0 0 90%;
}

.button-cluster {
  .addon, .sortable-ghost {
    display:none;
  }
}

.addons {
  display:flex;  
  flex-wrap:wrap;
  width:92%;
  margin-top:.5rem;
  .empty-addon {
    background-color:darken(white, 6%);
    font-size:.7em;    
  }
}

.ripple-scrim {
  position:absolute;
  height:100%;
  width:100%;
  top:0;right:0;bottom:0;left:20px;
  display:flex;
  align-items:stretch;
  .scrim-inner {
    flex: 1 1 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Menus/MenuItem.vue